import React from 'react';

import { compose } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import ContentLoader from 'react-content-loader';
import { injectIntl } from 'react-intl';
import { withTheme } from '@material-ui/core/styles';
import findicon1 from 'assets/images/hci1.png';
import { withRouter } from 'react-router-dom';

import HOCSectionLoader from '../HOC/HOCSectionLoader';
var isMounted = false;
class FindYourService extends React.Component {
    state = {
        expanded: false,
        clickValue: false,
        itemId: '',
        markedFav: 0,
        serviceList: [],
        loader: false
    };
    componentDidMount() {
        isMounted = true;

        this.getData();
    }
    componentWillUnmount() {
        isMounted = false;
    }
    getData = () => {
        if (isMounted) {
            this.setState({ loader: true });
            this.props.serviceListAction(this.onDone);
        }
    };
    onDone = (success, data) => {
        this.setState({ loader: false });
        if (success) {
            this.setState({ serviceList: data.data });
        }
    };
    handleExpandClick = () => {
        this.setState(state => ({ expanded: !state.expanded }));
    };
    renderLoading = index => {
        return (
            <div className="col-xs-12" key={index}>
                <ContentLoader
                    height={300}
                    width={300}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="13" rx="2" ry="2" width="280" height="200" />
                    <circle cx="25" cy="250" r="15" />
                    <rect
                        x="50"
                        y="240"
                        rx="4"
                        ry="4"
                        width="100"
                        height="10"
                    />
                    <rect x="50" y="260" rx="3" ry="3" width="50" height="8" />
                    <rect x="10" y="290" rx="3" ry="3" width="200" height="8" />
                </ContentLoader>
            </div>
        );
    };
    renderImageLoading = () => {
        return (
            <div>
                <ContentLoader
                    height={250}
                    width={280}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="2" ry="2" width="280" height="250" />
                </ContentLoader>
            </div>
        );
    };
    actionCallbacks(action, res) {
        if (action === 'view') {
            this.props.providerSelected(res);
        }
    }
    renderAllService = () => {
        this.props.history.push(`/category/services`);
    };
    handleClick = service => {
        this.props.history.push({ pathname: `/provider/list/${service.slug}` });
    };

    render() {
        const { serviceList, loader } = this.state;

        const { formatMessage } = this.props.intl;
        return (
            <div className="com-padd com-padd-redu-bot1 pad-bot-red-40">
                <div className="container">
                    <div className="row">
                        <div className="text-center col-12 com-title">
                            <h2>Find your Services</h2>
                            <p>
                                Explore some of the best business from around
                                the world from our partners and friends.
                            </p>
                        </div>
                        <div className="col-md-12">
                            <HOCSectionLoader loading={loader}>
                                <div className="dir-hli">
                                    <ul className="serv-list">
                                        {serviceList.length > 0 &&
                                            serviceList
                                                .slice(0, 8)
                                                .map((service, index) => {
                                                    return (
                                                        <li
                                                            className="col-lg-3 col-md-4 col-sm-6"
                                                            key={index}
                                                        >
                                                            <a
                                                                style={{
                                                                    cursor:
                                                                        'pointer'
                                                                }}
                                                                onClick={() =>
                                                                    this.handleClick(
                                                                        service
                                                                    )
                                                                }
                                                            >
                                                                <div className="dir-hli-5">
                                                                    <div className="dir-hli-1">
                                                                        <div className="dir-hli-3">
                                                                            <img
                                                                                src={
                                                                                    findicon1
                                                                                }
                                                                                alt="icon"
                                                                                className="findicon1"
                                                                            />
                                                                        </div>
                                                                        <div className="dir-hli-4" />
                                                                        <img
                                                                            src={
                                                                                service
                                                                                    .image
                                                                                    .medium
                                                                            }
                                                                            alt="service"
                                                                        />
                                                                    </div>
                                                                    <div className="dir-hli-2">
                                                                        <h4>
                                                                            {
                                                                                service.heading
                                                                            }
                                                                        </h4>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </li>
                                                    );
                                                })}
                                    </ul>
                                    <div className="text-right">
                                        <span
                                            onClick={this.renderAllService}
                                            className="dir-ho-cat"
                                        >
                                            Show All
                                        </span>
                                    </div>
                                </div>
                            </HOCSectionLoader>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const composedComponent = compose(
    withTheme(),

    connect(null, actions)
);
export default composedComponent(injectIntl(withRouter(FindYourService)));



// WEBPACK FOOTER //
// ./src/components/Providers/FindYourService.js